import { ApiLink, LEAD_ID } from "./urls";

const getQuestions = async (callback) => {
  let data = await fetch(
    `${ApiLink()}quiz/GetQuestions?id=${LEAD_ID}`
  ).then((res) => res.json());
  callback(data);
};

const isExist = async (jsonData, startup, finished, success, fail) => {
  startup();
  var form = new FormData();
  for (var key in jsonData) {
    form.append(key, jsonData[key]);
  }
  let data = await fetch(`${ApiLink()}isExists`, {
    method: "POST",
    body: form,
  }).then((res) => res.json());
  if (data) {
    fail();
  } else {
    success();
  }
  finished();
};

const SendLead = async (jsonData) => {
  var form = new FormData();
  for (var key in jsonData) {
    if (jsonData[key] instanceof Array) {
      form.append(key, JSON.stringify(jsonData[key]));
    } else {
      form.append(key, jsonData[key]);
    }
  }

  await fetch(`${ApiLink()}Save`, {
    method: "POST",
    body: form,
  })
    .then((res) => res.json())
    .then((js) => console.log(js));
};

export { getQuestions, isExist, SendLead };
